import { Subject } from '../Subject';
import { multicast } from './multicast';
import { connect } from './connect';
export function publish(selector) {
    return selector ? connect(selector) : multicast(new Subject());
}
//# sourceMappingURL=publish.js.map